import React from 'react';
import { ReactComponent as Warning } from '../../assets/icons/warning.svg';
import TwDialog from '../TwDialog/TwDialog';
import { TwButton, TwButtonType } from '../TwButtons/TwButtons';
import './TwWarningHelper.scss';
import { Validation } from '../../redux/api/validationsHelper/validationsHelper.model';

export interface TwWarningHelperProps {
  validations: Validation[];
  open: boolean;
  handleClose: () => void;
  onContinue?: () => void;
}

const TwWarningHelper: React.FC<TwWarningHelperProps> = ({
  validations,
  open,
  handleClose,
  onContinue
}): JSX.Element => {
  const handleCloseWarning = (): void => {
    handleClose();
  };

  const handleContinue = (): void => {
    onContinue && onContinue();
  };

  const getClass = (status: string): string => {
    switch (status) {
      case 'Expiring soon':
        return 'expiring-soon';
      case 'Expired':
        return 'expired';
      default:
        return '';
    }
  };

  const getConnector = (status: string): string => {
    switch (status) {
      case 'Expiring soon':
        return 'is';
      case 'Expired':
        return 'has';
      default:
        return '';
    }
  };

  return (
    <TwDialog open={open} title="Dispatch helper" onClickClose={handleCloseWarning}>
      <div className="warning-helper tid-warning-helper__content">
        <Warning />
        <div className="warning-helper__message">
          <div>
            <b>Attention: Potential dispatch issue detected</b>
          </div>
          <div>Please review the following issues before proceeding:</div>
          <ul>
            {validations.map((validation, index) => (
              <li key={index}>
                {validation.message} {getConnector(validation.extraInfo?.status as string)}{' '}
                <span
                  className={
                    validation.extraInfo
                      ? `warning-helper__message--${getClass(
                          validation.extraInfo.status as string
                        )}`
                      : ''
                  }
                >
                  {validation.extraInfo ? validation.extraInfo.status : ''}
                </span>
              </li>
            ))}
          </ul>
        </div>
        <div className="warning-helper__actions tid-warning-helper__actions">
          <TwButton
            fullwidth={false}
            label="Cancel"
            type={TwButtonType.secondary}
            action={handleCloseWarning}
          />

          <TwButton
            className="tid-warning-helper__continue"
            fullwidth={false}
            label="Ignore and proceed"
            type={TwButtonType.primary}
            action={handleContinue}
          />
        </div>
      </div>
    </TwDialog>
  );
};

export default TwWarningHelper;
